<!--<app-loader [loader]="loader.count" *ngIf="loader.count > 0"></app-loader>-->

<app-header></app-header>

<div class="container main-container"
     [ngStyle]="{ 'background-image': catalogueService.getProperty('imageBackground') ? 'url(' + catalogueService.getProperty('imageBackground') + ')' : 'none' }">

  <app-edition-panel *ngIf="loginService.isAuth()" [catalogueId]="eventData['id']" [hidesEditItem]="true"></app-edition-panel>

  <app-menu-tabs [filter]="'ONLY_PRODUCTS'"></app-menu-tabs>

  <div class="container-fluid counter">
    {{ numElements }} {{ 'products' | customTranslation:'MENU_TABS.PRODUCTS':translateService.currentLang | translate | lowercase }}
  </div>


<app-card style="display: none;"></app-card>


<div class="container-fluid"> 
  <card-grid *ngIf="selectedView === 'grid'" [page]="page" [items]="items" [show]="show" [banner]="getBannerByType('grid')"></card-grid>
  <card-modern *ngIf="selectedView === 'modern'" [page]="page" [items]="items" [show]="show" [banner]="getBannerByType('modern')"></card-modern>
  <card-list *ngIf="selectedView === 'list'" [page]="page" [items]="items" [show]="show" [banner]="getBannerByType('list')"></card-list>
</div>
    <loader-throbber *ngIf="loader.count > 0"></loader-throbber>
<div *ngIf="showAddMore()">
  <button class="see_more_button" [style.color]="catalogueService.getProperty('languageColor')" [style.backgroundColor]="mainColor" (click)="pages()">{{ 'COMMON.SHOW_MORE' | translate }}</button>
</div>

  <app-no-results *ngIf="items.length === 0 && loader.count === 0"></app-no-results>

</div>


<!-- <app-card-detail  style="display: none;"></app-card-detail>
 -->
<app-footer></app-footer>
